<template>
    <router-view v-if="have_permission"></router-view>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data: () => ({
    settings_user_permission: {
      haveRights: null,
      sections: {},
    },
    have_permission: true,
  }),

  created: function () {
    this.settings_user_permission.haveRights = this.user?.role?.permissions?.operatorPanel?.settings?.route?.haveRights
    this.settings_user_permission.sections = this.user?.role?.permissions?.operatorPanel?.settings?.sections

    this.checkUserPermission()
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
  },

  watch:{
    $route (){
      this.checkUserPermission()
    },
  },

  methods: {
    checkUserPermission() {
      // const currentTab = this.$route?.name
      const currentTab = 'users'
      let tabInPermission = false

      if (this.user?.role.alias === 'root'){
        tabInPermission = true
      } else {
        tabInPermission = this.settings_user_permission.sections?.[currentTab]?.canShow
      }

      this.have_permission = this.settings_user_permission.haveRights && tabInPermission
    },
  },
}
</script>
